export const siteStats = [
  { id: "s1", icon: "ri-film-line", value: "12,800+", label: "收录剧集影片" },
  { id: "s2", icon: "ri-refresh-line", value: "200+", label: "日均更新条目" },
  { id: "s3", icon: "ri-hd-line", value: "98%", label: "高清资源占比" },
  { id: "s4", icon: "ri-star-smile-line", value: "9.0", label: "观众平均评分" },
];

export const heroHighlights = [
  "在线观看，点开即播，无需跳转第三方页面",
  "免费追剧，收藏剧集后自动记录观看进度",
  "高清观影，支持标清 / 高清 / 蓝光多档切换",
  "全集观看，完结剧集一次性放送，无需等待",
];

export const platformFeatures = [
  {
    id: "f1",
    icon: "ri-live-line",
    title: "在线观看，开屏即播",
    desc: "进入播放页即自动加载正片，跳过繁琐的跳转与登录步骤。播放进度、声音大小与清晰度会被记住，下次打开直接续播。",
    tag: "在线观看",
  },
  {
    id: "f2",
    icon: "ri-heart-3-line",
    title: "免费追剧，一键收藏",
    desc: "把想看的剧加入追剧清单，更新后会在清单顶部提示。追剧记录只保存在本地设备，不需要注册账号也能长期使用。",
    tag: "免费追剧",
  },
  {
    id: "f3",
    icon: "ri-movie-2-line",
    title: "高清观影，画质自选",
    desc: "同一部剧提供标清、高清、蓝光多档码率，网络波动时自动降档，弱网也能顺畅观看，流量充足时再手动切回蓝光。",
    tag: "高清观影",
  },
  {
    id: "f4",
    icon: "ri-stack-line",
    title: "全集观看，完结直放",
    desc: "已完结的剧集按顺序排布全部集数，支持连播与倍速；连载中的剧集则按更新日历提示下一集上线时间。",
    tag: "全集观看",
  },
];

export const hotShows = [
  {
    id: "hot-1",
    title: "长风渡月",
    genre: "古装",
    tags: ["权谋", "爱情", "群像"],
    rating: "9.2",
    year: "2026",
    episodes: "全 46 集",
    status: "已完结",
    summary: "边关将领与书院女官因一纸盟约被绑在一起，从相互试探到并肩推行新政，在朝堂与沙场之间守住心中明月。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20historical%20drama%20poster%2C%20elegant%20scholar%20and%20general%20silhouettes%20under%20a%20huge%20moon%2C%20deep%20crimson%20and%20amber%20tonality%2C%20ink%20wash%20texture%2C%20moody%20warm%20lighting%2C%20rich%20shadows%2C%20premium%20poster%20art%2C%20high%20detail&width=600&height=800&seq=hot-cover-01&orientation=portrait",
  },
  {
    id: "hot-2",
    title: "雾港迷案",
    genre: "悬疑",
    tags: ["犯罪", "推理", "群像"],
    rating: "8.8",
    year: "2026",
    episodes: "更新至 24 集",
    status: "连载中",
    summary: "一起沉船旧案重新翻出水面，港口刑警与法医在潮湿的雨夜里追查线索，越接近真相越发现证词里全是熟悉的名字。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20poster%2C%20rainy%20harbor%20at%20night%20with%20fog%20and%20neon%20reflections%2C%20lone%20detective%20silhouette%2C%20muted%20warm%20brown%20and%20amber%20tones%2C%20grainy%20film%20texture%2C%20tense%20mood%2C%20premium%20poster%20art%2C%20high%20detail&width=600&height=800&seq=hot-cover-02&orientation=portrait",
  },
  {
    id: "hot-3",
    title: "都市浮生",
    genre: "都市",
    tags: ["职场", "情感", "成长"],
    rating: "8.5",
    year: "2025",
    episodes: "全 40 集",
    status: "已完结",
    summary: "三位合租的年轻人在一座不眠的城市里轮流失业又轮流上岸，把合租屋的灯光当成彼此最稳定的坐标。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20urban%20drama%20poster%2C%20rainy%20city%20skyline%20seen%20through%20apartment%20window%2C%20warm%20interior%20lamplight%2C%20terracotta%20and%20cream%20palette%2C%20soft%20haze%2C%20editorial%20poster%20art%2C%20high%20detail%2C%20calm%20mood&width=600&height=800&seq=hot-cover-03&orientation=portrait",
  },
  {
    id: "hot-4",
    title: "星轨之外",
    genre: "科幻",
    tags: ["冒险", "太空", "悬疑"],
    rating: "9.0",
    year: "2026",
    episodes: "更新至 18 集",
    status: "连载中",
    summary: "一支远航船队在偏离既定星轨后收到来自未来的求救信号，船员必须在返航与调查之间做出无法两全的选择。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20poster%2C%20distant%20space%20fleet%20near%20a%20warm%20amber%20planet%2C%20deep%20orange%20and%20charcoal%20tonality%2C%20stardust%20texture%2C%20dramatic%20glow%2C%20premium%20poster%20art%2C%20high%20detail&width=600&height=800&seq=hot-cover-04&orientation=portrait",
  },
  {
    id: "hot-5",
    title: "山海奇谭",
    genre: "奇幻",
    tags: ["神话", "志怪", "群像"],
    rating: "8.7",
    year: "2025",
    episodes: "全 36 集",
    status: "已完结",
    summary: "少年画师笔下的山海异兽在某夜离纸而出，他不得不背着画卷走过九州，替每一只走失的神兽找回自己的传说。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20poster%2C%20mythical%20beasts%20emerging%20from%20an%20ink%20scroll%2C%20golden%20and%20crimson%20mist%2C%20traditional%20Chinese%20painting%20texture%2C%20dramatic%20warm%20light%2C%20premium%20poster%20art%2C%20high%20detail&width=600&height=800&seq=hot-cover-05&orientation=portrait",
  },
  {
    id: "hot-6",
    title: "青春纪事",
    genre: "青春",
    tags: ["校园", "成长", "群像"],
    rating: "8.3",
    year: "2025",
    episodes: "全 30 集",
    status: "已完结",
    summary: "六个性格迥异的高三学生，在最后一年里一起写题、一起逃晚自习，也一起学着怎么和旧朋友好好告别。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20youth%20campus%20drama%20poster%2C%20sunlit%20classroom%20window%20with%20floating%20dust%2C%20soft%20peach%20and%20cream%20tones%2C%20nostalgic%20warm%20light%2C%20gentle%20film%20grain%2C%20premium%20poster%20art%2C%20high%20detail&width=600&height=800&seq=hot-cover-06&orientation=portrait",
  },
];

export const newReleases = [
  {
    id: "new-1",
    title: "归途列车",
    genre: "剧情 / 家庭",
    updateDay: "每周一更新",
    progress: "更新至 8 集",
    total: "共 32 集",
    premierDate: "2026-09-14",
    summary: "一位长途列车员用二十年的往返，替离家的人把想说的话一件件带回家。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20poster%2C%20warm%20sunset%20railway%20platform%20with%20a%20departing%20train%2C%20amber%20and%20terracotta%20tones%2C%20soft%20nostalgic%20haze%2C%20premium%20poster%20art%2C%20high%20detail&width=400&height=560&seq=new-cover-01&orientation=portrait",
  },
  {
    id: "new-2",
    title: "锦衣少年行",
    genre: "古装 / 武侠",
    updateDay: "每周三更新",
    progress: "更新至 12 集",
    total: "共 40 集",
    premierDate: "2026-08-20",
    summary: "初入锦衣卫的少年只想查清兄长旧案，却在一次押解任务里牵出牵连半座京城的密信。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20martial%20arts%20poster%2C%20young%20swordsman%20on%20ancient%20rooftop%20under%20crimson%20lanterns%2C%20dark%20gold%20and%20crimson%20tonality%2C%20dynamic%20composition%2C%20premium%20poster%20art%2C%20high%20detail&width=400&height=560&seq=new-cover-02&orientation=portrait",
  },
  {
    id: "new-3",
    title: "深蓝回声",
    genre: "科幻 / 悬疑",
    updateDay: "每周五更新",
    progress: "更新至 6 集",
    total: "共 24 集",
    premierDate: "2026-09-05",
    summary: "深海观测站连续收到同一段回声，值班员发现用声波拼出的竟是一句呼救。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20deep%20sea%20sci-fi%20poster%2C%20dark%20underwater%20research%20station%20with%20amber%20warning%20lights%2C%20deep%20teal%20and%20warm%20orange%20accent%2C%20eerie%20glow%2C%20premium%20poster%20art%2C%20high%20detail&width=400&height=560&seq=new-cover-03&orientation=portrait",
  },
  {
    id: "new-4",
    title: "茶马古道",
    genre: "历史 / 纪实",
    updateDay: "每周六更新",
    progress: "更新至 10 集",
    total: "共 20 集",
    premierDate: "2026-08-01",
    summary: "沿着古道重走一段商队往事，从驮铃声响讲到沿途城镇的兴衰与手艺人的坚守。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20historical%20documentary%20poster%2C%20caravan%20on%20mountain%20road%20at%20dawn%2C%20warm%20ochre%20and%20cream%20palette%2C%20misty%20mountain%20layers%2C%20earthy%20texture%2C%20premium%20poster%20art%2C%20high%20detail&width=400&height=560&seq=new-cover-04&orientation=portrait",
  },
  {
    id: "new-5",
    title: "笑看风云",
    genre: "喜剧 / 都市",
    updateDay: "每周日更新",
    progress: "更新至 14 集",
    total: "共 36 集",
    premierDate: "2026-07-12",
    summary: "一个落魄的相声演员被迫去写字楼上班，把每一场会议都开成了单口专场。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20comedy%20poster%2C%20cheerful%20office%20scene%20with%20warm%20string%20lights%2C%20mustard%20yellow%20and%20cream%20palette%2C%20playful%20composition%2C%20soft%20warm%20light%2C%20premium%20poster%20art%2C%20high%20detail&width=400&height=560&seq=new-cover-05&orientation=portrait",
  },
];

export const genres = [
  { id: "g1", name: "古装", count: 128, icon: "ri-vip-diamond-line", desc: "宫闱权谋、江湖侠义与家国叙事" },
  { id: "g2", name: "悬疑", count: 96, icon: "ri-spy-line", desc: "推理、犯罪与心理博弈" },
  { id: "g3", name: "都市", count: 143, icon: "ri-building-2-line", desc: "职场、情感与生活切片" },
  { id: "g4", name: "科幻", count: 74, icon: "ri-planet-line", desc: "太空、未来设定与硬核想象" },
  { id: "g5", name: "奇幻", count: 62, icon: "ri-magic-line", desc: "神话志怪与东方幻想" },
  { id: "g6", name: "青春", count: 88, icon: "ri-graduation-cap-line", desc: "校园、成长与友情岁月" },
  { id: "g7", name: "历史", count: 53, icon: "ri-ancient-gate-line", desc: "纪实、朝代与人物传记" },
  { id: "g8", name: "喜剧", count: 91, icon: "ri-emotion-happy-line", desc: "情景、轻喜与生活段子" },
  { id: "g9", name: "武侠", count: 45, icon: "ri-sword-line", desc: "门派恩怨与快意恩仇" },
  { id: "g10", name: "家庭", count: 67, icon: "ri-home-heart-line", desc: "亲情、代际与烟火日常" },
];

export const guideSteps = [
  {
    step: "01",
    title: "先锁定想看的剧",
    desc: "在「热播推荐」里按题材标签筛选，或在「新剧上线」里看更新节奏，先挑一部作为本次追剧目标，避免在列表里反复犹豫。",
  },
  {
    step: "02",
    title: "加入追剧清单",
    desc: "点开卡片上的追剧按钮，剧集会被记录在本地清单中。连载剧更新后清单会靠前显示，已完结剧则保留在你上次看到的那一集。",
  },
  {
    step: "03",
    title: "按需选择清晰度",
    desc: "通勤用手机看选标清省流量，在家用大屏看切到高清或蓝光。清晰度与音量会被记住，换设备后无需每次重新设置。",
  },
  {
    step: "04",
    title: "善用连播与倍速",
    desc: "全集观看时打开连播，片尾自动接下一集；剧情熟悉或二刷时用倍速跳过高密度对话，重要的转折再切回原速细看。",
  },
];

export const qualityModes = [
  { id: "q1", name: "标清", res: "480P", desc: "流量友好，地铁与移动网络下也能连续播放", icon: "ri-signal-wifi-1-line" },
  { id: "q2", name: "高清", res: "720P", desc: "日常观看首选，画面与人脸细节清晰可辨", icon: "ri-signal-wifi-2-line" },
  { id: "q3", name: "超清", res: "1080P", desc: "大屏观看推荐，夜景与动作场面对比更自然", icon: "ri-signal-wifi-3-line" },
  { id: "q4", name: "蓝光", res: "1080P+", desc: "家庭宽带稳定时开启，色彩与暗部层次更完整", icon: "ri-hd-line" },
];

export const devices = [
  { id: "d1", name: "手机 / 平板", desc: "竖屏目录、横屏播放，进度自动同步", icon: "ri-smartphone-line" },
  { id: "d2", name: "电脑浏览器", desc: "标签页式选集，键盘快捷操作更顺手", icon: "ri-computer-line" },
  { id: "d3", name: "智能电视", desc: "大屏浏览封面墙，遥控器即可选集", icon: "ri-tv-2-line" },
  { id: "d4", name: "投屏播放", desc: "同一网络下把手机画面投到大屏继续看", icon: "ri-cast-line" },
];

export const weeklySchedule = [
  { day: "周一", shows: ["归途列车 · 更新第 9 集", "都市浮生 · 重播精选"] },
  { day: "周二", shows: ["雾港迷案 · 更新第 25 集"] },
  { day: "周三", shows: ["锦衣少年行 · 更新第 13 集", "山海奇谭 · 全集连播"] },
  { day: "周四", shows: ["长风渡月 · 精编回顾"] },
  { day: "周五", shows: ["深蓝回声 · 更新第 7 集", "星轨之外 · 更新第 19 集"] },
  { day: "周六", shows: ["茶马古道 · 更新第 11 集"] },
  { day: "周日", shows: ["笑看风云 · 更新第 15 集", "青春纪事 · 全集连播"] },
];

export const faqs = [
  {
    q: "大师兄影视需要注册账号才能观看吗？",
    a: "不需要。在线观看与免费追剧的基本功能可以直接使用，追剧清单与播放进度保存在你当前设备上。只有在你希望跨设备同步清单时，才需要额外的同步设置。",
  },
  {
    q: "为什么同一部剧会有多个清晰度选项？",
    a: "不同网络环境适合的码率不同。标清适合移动网络，高清适合日常观看，超清与蓝光更适合大屏和稳定宽带。播放器会根据网速自动调整，你也可以手动锁定某一个档位。",
  },
  {
    q: "连载中的剧集多久更新一次？",
    a: "连载剧通常按固定星期更新，具体节奏可在「追剧日历」中查看。页面标注的是计划更新时间，遇到节假日或排期调整时可能顺延，以剧集页面最新标注为准。",
  },
  {
    q: "已完结的剧可以一次性看完吗？",
    a: "可以。已完结剧集会按顺序排布全部集数，打开连播后片尾会自动接入下一集，也可以手动从任意一集开始观看。",
  },
  {
    q: "观看记录保存在哪里？",
    a: "观看进度与追剧清单默认保存在浏览器本地，清除浏览器数据会一并清除。若希望长期保留，建议开启跨设备同步并在常用设备上保持登录状态。",
  },
  {
    q: "遇到卡顿或加载失败怎么办？",
    a: "可以先切换到更低的清晰度，或等待播放器自动降档；若仍无法播放，尝试刷新页面或更换网络环境，通常是临时线路波动导致。",
  },
];